import { Services, buildOrigin, createEnvironmentBaseURL, getSiteURL, normalizeURLPath, resolveOriginParts, runtimeDefaults, stringsToValidURLPath } from '@sigma-frontend-libs/commons'

const environmentBaseURL = createEnvironmentBaseURL(process.env.SERVER_ADDRESS, process.env.SERVER_PROTOCOL)

/**
 * Возвращает клиентские опции API для `GFetch`.
 *
 * @param path Необязательный дополнительный путь сервиса или ресурса.
 * @returns Нормализованные опции `protocol`, `baseURL`, `path` и `port`.
 */
export const getClientOptions = (path = '') => {
  const backendOriginParts = resolveOriginParts(environmentBaseURL)
  const pathParts = [ runtimeDefaults.path ]
  const normalizedPath = normalizeURLPath(path)
  if (normalizedPath) {
    pathParts.push(normalizedPath)
  }

  return {
    protocol: backendOriginParts.protocol,
    baseURL: backendOriginParts.hostname,
    path: stringsToValidURLPath(pathParts),
    port: backendOriginParts.port
  }
}

/**
 * Возвращает базовый адрес для WebSocket-подключения.
 *
 * Если socket адрес не переопределён, используется адрес API. Для защищённых
 * адресов протокол автоматически переводится в `wss`.
 *
 * @returns Полный адрес WebSocket без дополнительного пути.
 */
export const getSocketURL = () => {
  const origin = resolveOriginParts(environmentBaseURL)
  let protocol = runtimeDefaults.protocols.ws.insecure
  if (origin.protocol === runtimeDefaults.protocols.http.secure || origin.protocol === runtimeDefaults.protocols.ws.secure) {
    protocol = runtimeDefaults.protocols.ws.secure
  }

  return buildOrigin(origin, protocol)
}

/**
 * Собирает абсолютный `URL` для API-ресурса.
 *
 * @param value Дополнительный путь ресурса внутри API строкой или списком сегментов.
 * @returns Абсолютный `URL` для API-ресурса строкой.
 */
export const getURLtoAPI = (value = '') => {
  const pathParts = [ runtimeDefaults.path ]
  if (Array.isArray(value)) {
    pathParts.push(...value)
  } else {
    pathParts.push(value)
  }

  const path = getSiteURL(pathParts, environmentBaseURL)
  const url = new URL(path)

  return url.toString()
}

/**
 * Собирает полный URL ресурса в storage.
 *
 * @param value Необязательный путь или список сегментов внутри storage.
 * @returns Полный URL ресурса в storage строкой.
 */
export const getStorageURL = (value = []) => {
  return getURLtoAPI([ Services.storage, ...value ])
}
